/*
 * Extract tenantId from original search params before filtering
 * const originalSearchParams = new URLSearchParams(prevSearch);
 * const tenantId = originalSearchParams.get(TENANT_ID_PARAM);
 */
import { type To } from "@cinnamon/design-system/hooks";

import { TENANT_ID_PARAM } from "@/constants/config";
import { LOGIN_METHOD } from "@/constants/global";
import { LOGIN_SEARCH_PARAMS, ROUTE } from "@/constants/route";

export const buildRedirectTo = (prevPathName: string, prevSearch: string, loginMethod: LOGIN_METHOD | null): To => {
  const originalSearchParams = new URLSearchParams(prevSearch);
  const tenantId = originalSearchParams.get(TENANT_ID_PARAM);

  const filteredSearchString = originalSearchParams.toString() ? `?${originalSearchParams.toString()}` : "";

  const loginPathname = loginMethod === LOGIN_METHOD.SSO ? ROUTE.SSO_LOGIN.to : ROUTE.LOGIN.to;
  const redirectSearchParams = new URLSearchParams();
  redirectSearchParams.set(LOGIN_SEARCH_PARAMS.REDIRECT_TO, `${prevPathName}${filteredSearchString}`);

  if (tenantId) {
    redirectSearchParams.set(TENANT_ID_PARAM, tenantId);
  }

  const redirectSearchString = redirectSearchParams.toString();
  return {
    pathname: loginPathname,
    search: redirectSearchString,
  };
};
